var LanderHelper = function () {

    let benefitBrandImages = {
        'consultation': 'icon-2.png',
        'eyecare': 'icon-3.png',
        'petmedication': 'icon-4.png',
        'telemedicine': 'icon-5.png',
        'vaccine': 'icon-1.png',
        'firstorder': 'cashback.png',
        'cashback': 'cashback.png',
        'rxdelivery': 'icon-6.png'
    }
    function getBenefitImage(benefitType) {
        let brandImage = benefitBrandImages && benefitBrandImages[benefitType] ?  benefitBrandImages[benefitType] : "";
        return "/sl/images/" + (brandImage ? brandImage : 'sp-logo.png');
    }

    return {
        getBenefitImage: getBenefitImage
    }

}();

module.exports = LanderHelper;
